<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">Detalji izdvojene sekcija</h2>
                  <p class="card-big-info-desc">Unesite detalje</p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Naziv
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="category.title"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Naslov
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naslov"
                        v-model="category.contentTitle"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Glavni opis
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Glavni opis"
                        v-model="category.mainDescription"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Sporedni opis
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Sporedni opis"
                        v-model="category.secondaryDescription"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Link
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Link"
                        v-model="category.contentUrl"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Dostupno na</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="category.highlightedCategoryContentType"
                      >
                        <option
                          v-for="item in b2borb2cOptions"
                          :value="item.id"
                          :key="item.id"
                        >
                          {{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Vidljivo na glavnoj stranici?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          id="visible-on-main-page"
                          name="agreeterms"
                          type="checkbox"
                          v-model="category.visibleOnMainPage"
                        />
                        <label
                          class="control-label"
                          for="visible-on-main-page"
                        ></label>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Poravnanje
                    </label>

                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="category.alignment"
                        :multiple="false"
                        :options="alignments"
                        placeholder="Izaberite poravnanje"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label class="col-lg-5 col-xl-3 control-label text-lg-end mb-0">Slika slidera</label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="photo"
                        accept="image/*"
                        @change="handlePhotoUpload"
                      />
                      <span class="form-text">
                        Učitajte sliku rezolucije 855px x 480px
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1">
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
            exact
            :to="{ name: 'FeaturedCategories' }"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="ubmit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header"><strong>{{ translations.deleteHighlightedCategory }}</strong></h5>
        <div slot="body">
          <span v-html="modalText">
          </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button type="button" class="btn btn-primary px-4 mx-2" @click.prevent.stop="handleDelete" data-bs-dismiss="modal">
                {{ translations.yes }}
              </button>
              <button type="button" class="btn btn-default px-4" data-bs-dismiss="modal">
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

import { translations } from '@/mixins';
import Modal from '@/components/shared/modal/Modal.vue';
import api from '@/services/api';
import config from '@/config';

export default {
  name: 'EditHighlightedCategory',
  mixins: [translations],
  components: { Treeselect, Modal },
  data() {
    return {
      b2borb2cOption: 3,
      b2borb2cOptions: [
        {
          id: 1,
          text: 'B2B',
        },
        {
          id: 2,
          text: 'B2C',
        },
        {
          id: 3,
          text: 'Sve',
        },
      ],
      alignments: [
        {
          id: 'left',
          label: 'Lijevo',
        },
        {
          id: 'right',
          label: 'Desno',
        },
      ],
      imageUrl: '',
    };
  },
  computed: {
    baseUrl() {
      return config.baseUrl;
    },
    category() {
      return this.$store.getters.getHighlightedCategory;
    },
    modalText() {
      return this.translations.areYouSureHighlightedCategory.replace('{category}', `<strong>${this.category.title}</strong>`);
    },
  },
  methods: {
    submitForm() {
      const {
        id,
        contentTitle,
        mainDescription,
        title,
        secondaryDescription,
        alignment,
        contentUrl,
        visibleOnMainPage,
        highlightedCategoryContentType,
      } = this.category;

      const payload = {
        id,
        contentTitle,
        title,
        mainDescription,
        secondaryDescription,
        alignment,
        contentUrl,
        visibleOnMainPage,
        highlightedCategoryContentType
      };


      if (this.$refs.photo.files[0]) {
        const file = this.$refs.photo.files[0];

        payload.image = {
          file: this.imageUrl.split(',')[1],
          fileName: file.name
        };
      }

      api.updateHighlightedCategory(payload).then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: 'FeaturedCategories' });
      });
    },
    handleDelete() {
      api.deleteHighlightedCategory(this.category.id)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: 'FeaturedCategories' });
        })
        .catch((err) => {
          this.$toast.error(err.response.data.info);
        });
    },
    handlePhotoUpload() {
      const file = this.$refs.photo.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = (e) => {
        this.imageUrl = e.target.result;
      };
    },
  },
  mounted() {
    this.$store.dispatch('getHighlightedCategory', this.$route.params.id);
  },
};
</script>
